var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-text-center",class:_vm.exTypeTagCls(_vm.row.exCatalog)},[_vm._v(" "+_vm._s(_vm.exType[_vm.row.exCatalog] && _vm.$t(_vm.alarmReason[_vm.row.exCatalog].title))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }